import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { createUUID } from "@miplatform/utils";
import { PLAN_SERIES_TAB_VALUES } from "../../../constants";

const PLAN_STATUS = {
  [PLAN_SERIES_TAB_VALUES.ALL_PLANS]: undefined,
  [PLAN_SERIES_TAB_VALUES.ACTIVE_PLANS]: "Active",
  [PLAN_SERIES_TAB_VALUES.INACTIVE_PLANS]: "Inactive",
};

export const usePlanSeriesCommunitiesPlansTabViewModel = ({
  stateManager,
  accountId,
  seriesOrCommunityId,
  seriesOrCommunityTab,
  tab,
}) => {
  const [specPlans, setSpecPlans] = useState([]);
  const [recentSpecPlans, setRecentSpecPlans] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const GET_SPEC_PLANS_UUID = createUUID();
  const GET_RECENT_SPEC_PLANS_UUID = createUUID();
  const HANDLE_DELETE_SPEC_PLAN_UUID = createUUID();

  const getSpecPlans = ({ top, skip }) => {
    stateManager.abort(GET_SPEC_PLANS_UUID);
    return stateManager.run(() => {
      return homeService.plans.getAll({
        sort: "name asc",
        filters: {
          builderId: { type: "guid", value: accountId },
          planStatus: PLAN_STATUS[seriesOrCommunityTab],
          ...(tab === "communities"
            ? { communityId: { type: "guid", value: seriesOrCommunityId } }
            : {
                seriesId: { type: "guid", value: seriesOrCommunityId },
                communityId: { type: "guid", value: null },
              }),
        },
        top,
        skip,
      });
    }, GET_SPEC_PLANS_UUID);
  };

  const getRecentSpecPlans = ({ sort, filters = {}, top }) => {
    stateManager.abort(GET_RECENT_SPEC_PLANS_UUID);
    return stateManager.run(async () => {
      const mergedFilters = {
        ...filters,
        builderId: { type: "guid", value: accountId },
        planStatus: PLAN_STATUS[seriesOrCommunityTab],
        ...(tab === "communities"
          ? { communityId: { type: "guid", value: seriesOrCommunityId } }
          : {
              seriesId: { type: "guid", value: seriesOrCommunityId },
              communityId: { type: "guid", value: null },
            }),
      };
      return homeService.plans.getAll({ sort, filters: mergedFilters, top });
    }, GET_RECENT_SPEC_PLANS_UUID);
  };

  const handleRefresh = () => {
    setRefresh((prev) => !prev);
  };

  const handleDeleteSpecPlan = (data) => {
    stateManager.abort(HANDLE_DELETE_SPEC_PLAN_UUID);
    stateManager.run(async () => {
      const response = await homeService.plans.delete({
        id: data.id,
        modifiedOn: data.modifiedOn,
        toastMessageConfig: {
          success: {
            text: `${data.name} was deleted successfully.`,
          },
          failure: {
            text: `Failed to delete ${data.name}.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        handleRefresh();
      }
    }, HANDLE_DELETE_SPEC_PLAN_UUID);
  };

  return {
    specPlans,
    refresh,
    getSpecPlans,
    setSpecPlans,
    handleRefresh,
    handleDeleteSpecPlan,
    recentSpecPlans,
    setRecentSpecPlans,
    getRecentSpecPlans,
  };
};
